export function toYesNoOrUndefined(value?: boolean): string | undefined {
  if (value === true) {
    return 'Yes'
  } else if (value === false) {
    return 'No'
  }

  return undefined
}
